const CITY_CACHE_TTL_MS = 3 * 24 * 60 * 60 * 1000; // 3 days
const keyFor = (lat: number, lon: number, precision = 3, locale?: string) => {
  const r = (n: number) => Number(n.toFixed(precision));
  // Include locale in the cache key so labels are language-specific
  const lang = locale ? String(locale) : 'default';
  return `city@${r(lat)},${r(lon)}#${lang}`;
};

export const getCachedCity = (
  lat: number,
  lon: number,
  precision = 3,
  now = Date.now(),
  locale?: string,
): string | null => {
  try {
    const raw = localStorage.getItem(keyFor(lat, lon, precision, locale));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { city: string; ts: number } | null;
    if (!parsed) return null;
    if (now - parsed.ts > CITY_CACHE_TTL_MS) return null; // expired
    return parsed.city || null;
  } catch { return null; }
};

export const setCachedCity = (
  lat: number,
  lon: number,
  city: string,
  precision = 3,
  locale?: string,
): void => {
  try {
    localStorage.setItem(keyFor(lat, lon, precision, locale), JSON.stringify({ city, ts: Date.now() }));
  } catch { /* ignore quota/private mode */ }
};
